import React, { useState, useEffect, useRef, useCallback } from 'react';
import Navbar from '../components/Navbar.js'
import { Row, Col, Form, Button, Container, ButtonGroup } from 'react-bootstrap'
import { createRoot } from 'react-dom/client';
import moment from 'moment';
import { min } from 'moment';
import regions from '../JSON/regions.json';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getMonth, getYear } from 'date-fns';
import range from "lodash/range";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import states from '../JSON/us-state-boundaries.json'
import config from '../JSON/regions.json';

import { createGIF } from 'gifshot';
import { GoogleMap, LoadScript, GroundOverlay } from '@react-google-maps/api';
import html2canvas from 'html2canvas';
import debounce from 'lodash.debounce';
import Slider from '@mui/material/Slider';




var turf = require('@turf/turf');




const url00 = "https://sfr.umd.edu";
const ffn_php = "/api/sfr/getImgs1.php";
const ffn_phpm = "/api/sfr/getImgsM.php";
const fdn00 = "/home/jundong/www";




const GenerateGif = () => {
    const date = new Date();
    // UTC start and end dates
    const UTCStartDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    const UTCEndDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), Math.floor(date.getUTCMinutes() / 10) * 10);
    const [dates, setDates] = useState([UTCStartDate, UTCEndDate]);




    const [times, setTimes] = useState(["00:00", date.getUTCHours().toString().padStart(2, '0') + ":" + date.getUTCMinutes().toString().padStart(2, '0')]);
    const handleStartDate = (date) => {
        if (new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() === new Date(dates[0].getFullYear(), dates[0].getMonth(), dates[0].getDate()).getTime()) {
            setDates([date, dates[1]])
        } else {
            setDates([date, null])
        }
    }




    const getStartMaxTime = () => {
        if (UTCStartDate.getTime() === new Date(dates[0].getFullYear(), dates[0].getMonth(), dates[0].getDate()).getTime()) {
            return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())
        } else {
            return (new Date()).setHours(23, min = 59)
        }
    }




    const getEndMaxTime = () => {
        if (dates[1] && UTCStartDate.getTime() === new Date(dates[1].getFullYear(), dates[1].getMonth(), dates[1].getDate()).getTime()) {
            return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())
        } else {
            return (new Date()).setHours(23, min = 59)
        }
    }

    const getEndMinTime = () => {
        if (dates[1] && new Date(dates[0].getFullYear(), dates[0].getMonth(), dates[0].getDate()).getTime() === new Date(dates[1].getFullYear(), dates[1].getMonth(), dates[1].getDate()).getTime()) {
            return dates[0]
        } else {
            return (new Date()).setHours(0, min = 0)
        }
    }

    const getEndMaxDate = () => {
        var endBound = new Date(dates[0]);
        endBound.setDate(dates[0].getDate() + 7);
        if (endBound > UTCStartDate) {
            return UTCStartDate;
        }
        else {
            return endBound;
        }
    }




    useEffect(() => {
        var endBound = new Date(dates[0]);
        endBound.setDate(dates[0].getDate() + 1);




        if (dates[1] < dates[0]) {
            setDates([dates[0], endBound])
        }
        // console.log("dates[0]", dates[0])
        // console.log("dates[1]", dates[1])




    }, [dates])




    const years = range(2021, getYear(new Date()) + 1, 1);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];




    const [region, setRegion] = useState('msfr');
    const [frameDuration, setFrameDuration] = useState(200);
    const [opacity, setOpacity] = useState(70)
    const [map, setMap] = useState(null);
    const [timeRoot, setTimeRoot] = useState(null);
    const [controlsRoot, setControlsRoot] = useState(null);
    const [width, setWidth] = useState(document.documentElement.clientWidth - 400);
    const [height, setHeight] = useState(document.documentElement.clientHeight - 170);
    const [errorMsg, setErrorMsg] = useState(null);
    const [timeStep, setTimeStep] = useState(["10", "minutes"]);
    const [customBounds, setCustomBounds] = useState(null);
    const [maxFrames, setMaxFrames] = useState(36);
    const [zoomControl, setZoomControl] = useState(true);




    const [isCreatingGif, setIsCreatingGif] = useState(false);




    // New state for image preview functionality
    const [images, setImages] = useState(null);
    const [index, setIndex] = useState(0);
    const [looping, setLooping] = useState(false);
    const [loading, setLoading] = useState(false);
    const indexRef = useRef(index);




    useEffect(() => {
        indexRef.current = index;
    }, [index]);




    useEffect(() => {
        const updateDimensions = debounce(() => {
            setWidth(window.innerWidth - 400);
            setHeight(window.innerHeight - 170);
        }, 200);




        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);




    // Load images when dates, times, or region changes
    useEffect(() => {
        if (dates[0] && dates[1]) {
            loadPreviewImages();
        } else {
            setImages(null);
            setIndex(0);
        }
    }, [dates, timeStep]);


    useEffect(() => {
        if (map) {
            var paths = []
            for (let i = 0; i < states.length; i++) {
                var coords = states[i]['st_asgeojson']['geometry']['coordinates']
                for (let j = 0; j < coords.length; j++) {
                    var path = coords[j]
                    if (path.length === 1) {
                        path = path[0]
                    }
                    var latLngPath = []
                    for (let k = 0; k < path.length; k++) {
                        latLngPath.push(new window.google.maps.LatLng(path[k][1], path[k][0]))
                    }
                    paths.push(latLngPath)
                }
            }

            var polygons = new window.google.maps.Polygon({
                paths: paths,
                clickable: false,
                geodesic: false,
                // strokeColor: '#5A5A5A',
                strokeColor: '#000000',
                strokeOpacity: 1.0,
                strokeWeight: 0.4,
                fillOpacity: 0,
                map: map
            });
        }
    }, [map])

    // Image stepping functionality
    const handleIncrement = useCallback((increment) => {
        if (!images || images.length === 0) {
            setIndex(0);
            return;
        }




        let newIndex = (index + increment + images.length) % images.length;

        // If we have map bounds, filter to images that intersect
        if (map && customBounds) {
            const startIndex = index;
            let poly1 = turf.polygon([images[newIndex][2]]);
            let bounds = customBounds;

            let poly2, poly3;
            if (bounds.west < bounds.east) {
                poly2 = turf.polygon([[[bounds.west, bounds.north], [bounds.east, bounds.north], [bounds.east, bounds.south], [bounds.west, bounds.south], [bounds.west, bounds.north]]]);
                poly3 = turf.polygon([[[bounds.west - 360, bounds.north], [bounds.east - 360, bounds.north], [bounds.east - 360, bounds.south], [bounds.west - 360, bounds.south], [bounds.west - 360, bounds.north]]]);
            } else {
                poly2 = turf.polygon([[[bounds.west - 360, bounds.north], [bounds.east, bounds.north], [bounds.east, bounds.south], [bounds.west - 360, bounds.south], [bounds.west - 360, bounds.north]]]);
                poly3 = turf.polygon([[[bounds.west, bounds.north], [bounds.east + 360, bounds.north], [bounds.east + 360, bounds.south], [bounds.west, bounds.south], [bounds.west, bounds.north]]]);
            }

            while (!(turf.intersect(poly1, poly2) || turf.intersect(poly1, poly3)) && startIndex !== newIndex) {
                newIndex = (newIndex + increment + images.length) % images.length;
                poly1 = turf.polygon([images[newIndex][2]]);
            }
        }

        setIndex(newIndex);
    }, [index, images, map, customBounds]);




    // Auto-loop functionality
    useEffect(() => {
        if (images && images.length > 0 && looping) {
            const intervalTime = frameDuration && frameDuration >= 100 && frameDuration <= 2000 ? frameDuration : 200;
            const id = setInterval(() => handleIncrement(1), intervalTime);
            return () => clearInterval(id);
        }
    }, [images, looping, handleIncrement]);


    const momentFromResult = (entry) => {
        const url = entry[0];
        const m = url.match(/(?:_S)?(\d{8})_(\d{6})/);
        return m ? moment(m[1] + m[2], "YYYYMMDDHHmmss") : null;
      };
      
      const applyTimeStep = (sortedResults, stepValue, stepUnit) => {
        if (!stepValue || !stepUnit) return sortedResults;
        const out = [];
        let last = null;
      
        for (const r of sortedResults) {
          const t = momentFromResult(r);
          if (!t) continue;
          if (!last || t.diff(last, stepUnit) >= stepValue) {
            out.push(r);
            last = t;
          }
        }
        return out;
      };


    const loadPreviewImages = async () => {
        setLoading(true);
        setErrorMsg(null);
    
        try {
            const dateArray = getDates(dates[0], dates[1]);
            const results = [];
            let extensions;
    
            if (regions[region]["merged"]) {
                extensions = ["msfr"];
            } else {
                extensions = Object.keys(regions["satellites"]);
            }
    
            // filter to selected satellites if needed
            // (for now all, but you can mirror MapComponent's filtering logic)
    
            for (const [y, m, d] of dateArray) {
                const ym = `${y}${m}`;
                const ymd = `${y}${m}${d}`;
    
                for (const sat of extensions) {
                    let baseURL;
                    if (extensions[0] === "msfr") {
                        baseURL = `https://sfr.umd.edu/image_gm/conus/msfr/${ym}/`;
                    } else {
                        baseURL = `https://sfr.umd.edu/image_gm/${region}/${sat}/${ym}/`;
                    }
    
                    try {
                        const response = await fetch(baseURL);
                        const html = await response.text();
                        const matches = [...html.matchAll(new RegExp(`href="([^"]*${ymd}[^"]*\\.png)"`, "g"))]
                            .map(m => m[1]);
    
                        const dayResults = await Promise.all(matches.map(async (match) => {
                            const pngURL = baseURL + match;
                            const bdyURL = pngURL.replace(".png", ".bdy");
    
                            const timeMatch = match.match(/(?:_S)?(\d{8})_(\d{6})/);
                            if (!timeMatch) return null;
    
                            const imgMoment = moment(timeMatch[1] + timeMatch[2], "YYYYMMDDHHmmss");
                            if (!imgMoment.isBetween(moment(dates[0]), moment(dates[1]), null, '[]')) {
                                return null;
                            }
    
                            if (extensions[0] === "msfr") {
                                const box = { west: -130, east: -60, south: 20, north: 55 };
                                const polygon = [
                                    [box.west, box.south],
                                    [box.east, box.south],
                                    [box.east, box.north],
                                    [box.west, box.north],
                                    [box.west, box.south]
                                ];
                                return [pngURL, box, polygon];
                            } else {
                                const bdyResponse = await fetch(bdyURL);
                                const bdyText = await bdyResponse.text();
                                const lines = bdyText.trim().split("\n");
                                const firstLine = lines[0].trim().split(/\s+/);
                                const west = parseFloat(firstLine[1]);
                                const east = parseFloat(firstLine[2]);
                                const south = parseFloat(firstLine[3]);
                                const north = parseFloat(firstLine[4]);
                                const polygon = lines.slice(1).map(line => {
                                    const [lon, lat] = line.trim().split(/\s+/).map(Number);
                                    return [lon, lat];
                                });
                                polygon.push(polygon[0]); // close polygon
                                return [pngURL, { west, east, south, north }, polygon];
                            }
                        }));
    
                        results.push(...dayResults.filter(Boolean));
                    } catch (err) {
                        console.warn("Error fetching images", err);
                    }
                }
            }
    
            if (results.length > 0) {
                const imgRegex = region === "msfr"
                    ? /[0-9]{8}_[0-9]{6}/
                    : /S[0-9]{8}_[0-9]{6}/;
                results.sort((a, b) => {
                    const aTime = a[0].match(imgRegex)?.[0] ?? "";
                    const bTime = b[0].match(imgRegex)?.[0] ?? "";
                    return aTime.localeCompare(bTime);
                });

                let filtered = results;
                if(region === "msfr"){
                    const stepVal = parseInt(timeStep?.[0], 10);
                    const stepUnit = timeStep?.[1];
                    filtered = applyTimeStep(results, stepVal, stepUnit);
                }

                // Filter for max length 20
                var imagesMaxLength = [];
                for (var i = 0; i < filtered.length && i < maxFrames; i++) {
                    imagesMaxLength.push(filtered[i]);
                }

                setImages(imagesMaxLength);
                setIndex(0);
            } else {
                setImages(null);
                setErrorMsg("No images found for the selected parameters");
            }
            //console.log(results)

        } catch (error) {
            setErrorMsg(`Error loading images: ${error.message}`);
            setImages(null);
        }
    
        setLoading(false);
    };
    


    useEffect(() => {
        if (map && customBounds &&
            customBounds.north !== undefined &&
            customBounds.south !== undefined &&
            customBounds.east !== undefined &&
            customBounds.west !== undefined) {

            if (customBounds.north <= customBounds.south) {
                setErrorMsg("North latitude must be greater than South latitude");
                return;
            }

            const bounds = new window.google.maps.LatLngBounds(
                new window.google.maps.LatLng(customBounds.south, customBounds.west),
                new window.google.maps.LatLng(customBounds.north, customBounds.east)
            );
            map.fitBounds(bounds, { top: 0, bottom: 0, left: 0, right: 0 });
        }
    }, [customBounds, map]);




    const handleOnLoad = map => {
        // Time display
        const timeDiv = document.createElement('div');
        timeDiv.style.fontSize = "25px";
        timeDiv.style.fontFamily = "Roboto";
        timeDiv.style.marginTop = "10px";
        timeDiv.style.marginLeft = "10px";
        const timeRoot = createRoot(timeDiv);
        setTimeRoot(timeRoot);
        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(timeDiv);

        map.setOptions({
            zoomControlOptions: {
                position: window.google.maps.ControlPosition.TOP_RIGHT,
            }
        })




        // Controls
        const controlButtonDiv = document.createElement('div');
        controlButtonDiv.style.paddingRight = "10px";
        controlButtonDiv.style.fontSize = "15px";
        controlButtonDiv.style.fontFamily = "Roboto";
        controlButtonDiv.style.justifyContent = "center";
        controlButtonDiv.style.alignContent = "center";
        controlButtonDiv.style.display = "flex";
        const controlRoot = createRoot(controlButtonDiv);
        setControlsRoot(controlRoot);
        map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlButtonDiv);




        var timeout;
        window.google.maps.event.addListener(map, 'bounds_changed', function () {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                if (map) {
                    const bounds = map.getBounds();
                    if (bounds) {
                        const boundsObj = {
                            north: bounds.getNorthEast().lat(),
                            south: bounds.getSouthWest().lat(),
                            east: bounds.getNorthEast().lng(),
                            west: bounds.getSouthWest().lng()
                        };
                        setCustomBounds(boundsObj);

                        document.querySelector('input[placeholder="Max Latitude"]').value = boundsObj.north.toFixed(2);
                        document.querySelector('input[placeholder="Min Latitude"]').value = boundsObj.south.toFixed(2);
                        document.querySelector('input[placeholder="Max Longitude"]').value = boundsObj.east.toFixed(2);
                        document.querySelector('input[placeholder="Min Longitude"]').value = boundsObj.west.toFixed(2);
                    }
                }
            }, 100);
        });




        setMap(map);
    };




    // Update time display
    useEffect(() => {
        if (timeRoot && images && images[index] && images[index][0]) {
            timeRoot.render(
                <div style={{ padding: 5, backgroundColor: "#fff" }}>
                    {imgInfo(images[index][0]).join(' ')}
                </div>
            );
        } else if (timeRoot) {
            timeRoot.render(
                <div style={{ padding: 5, backgroundColor: "#fff" }}>
                    {loading ? "Loading images..." : "No Images Available"}
                </div>
            );
        }
    }, [images, index, timeRoot, loading]);

    // Reset parameters on region change
    useEffect(()=>{   
        setImages(null);     
        setLooping(false);
        setErrorMsg(null);
        setDates([UTCStartDate, UTCEndDate]);
        setIndex(0);
        setFrameDuration(200);
        resetMapBounds();
    },[region])




    // Update controls
    useEffect(() => {
        if (controlsRoot) {
            if (isCreatingGif) {
                setZoomControl(false);
                controlsRoot.render(null);
            } else {
                setZoomControl(true);
                controlsRoot.render(
                    !isCreatingGif && (
                        <div style={{
                            marginTop: "8px",
                            marginBottom: "8px",
                            backgroundColor: "#000",
                            paddingTop: "8px",
                            paddingBottom: "2px",
                            paddingLeft: "8px",
                            paddingRight: "8px"
                        }}>
                            <Button
                                className="border-secondary"
                                style={{ padding: "0.4rem 0.6rem" }}
                                size="md"
                                variant={looping ? "primary" : "light"}
                                onClick={() => setLooping(!looping)}
                                disabled={!images || images.length === 0}
                            >
                                Loop
                            </Button>
                            {' '}
                            <ButtonGroup>
                                <Button
                                    className="border-secondary"
                                    variant="light"
                                    onClick={() => { handleIncrement(-1); setLooping(false); }}
                                    disabled={!images || images.length === 0}
                                >
                                    ←
                                </Button>
                                <Button
                                    className="border-secondary"
                                    variant="light"
                                    onClick={() => { handleIncrement(1); setLooping(false); }}
                                    disabled={!images || images.length === 0}
                                >
                                    →
                                </Button>
                            </ButtonGroup>

                            {images && (
                                <div style={{ color: "#fff", fontSize: "14px", textAlign: "center", marginTop: "10px" }}>
                                    {images.length} images loaded
                                    <br />
                                    Frame {index + 1} of {images.length}
                                </div>
                            )}
                        </div>
                    )
                );
            }
        }
    }, [controlsRoot, looping, handleIncrement, images, index, isCreatingGif]);




    const resetMapBounds = () => {
        if (map) {
            map.setCenter(regions[region]["center"]);
            map.setZoom(regions[region]["zoom"]);
            setCustomBounds(null);
            document.querySelectorAll('input[placeholder*="Latitude"], input[placeholder*="Longitude"]').forEach(input => {
                input.value = '';
            });
        }
    };








    const handleClick = async () => {
        setErrorMsg(null);

        if (!images || images.length === 0) {
            setErrorMsg("No images loaded. Please check your date/time parameters.");
            return;
        }

        if (frameDuration === null || frameDuration < 100 || frameDuration > 1000) {
            setErrorMsg("Please enter a valid frame duration (100-1000 ms)");
            return;
        }

        if (opacity === null || opacity === ""|| opacity > 100 || opacity < 0) {
            setErrorMsg("Please enter a valid opacity (0-100%)");
            return;
        }

        if (map) {
            map.setOptions({ draggable: false, zoomControl: false });
        } else {
            setErrorMsg("Map not loaded");
            return;
        }





        // Filter images that intersect with current bounds
        let validImgs = images;
        if (customBounds) {
            validImgs = [];
            for (const img of images) {
                const poly1 = turf.polygon([img[2]]);
                let poly2, poly3;

                if (customBounds.west < customBounds.east) {
                    poly2 = turf.polygon([[[customBounds.west, customBounds.north], [customBounds.east, customBounds.north], [customBounds.east, customBounds.south], [customBounds.west, customBounds.south], [customBounds.west, customBounds.north]]]);
                    poly3 = turf.polygon([[[customBounds.west - 360, customBounds.north], [customBounds.east - 360, customBounds.north], [customBounds.east - 360, customBounds.south], [customBounds.west - 360, customBounds.south], [customBounds.west - 360, customBounds.north]]]);
                } else {
                    poly2 = turf.polygon([[[customBounds.west - 360, customBounds.north], [customBounds.east, customBounds.north], [customBounds.east, customBounds.south], [customBounds.west - 360, customBounds.south], [customBounds.west - 360, customBounds.north]]]);
                    poly3 = turf.polygon([[[customBounds.west, customBounds.north], [customBounds.east + 360, customBounds.north], [customBounds.east + 360, customBounds.south], [customBounds.west, customBounds.south], [customBounds.west, customBounds.north]]]);
                }

                if (turf.intersect(poly1, poly2) || turf.intersect(poly1, poly3)) {
                    validImgs.push(img);
                }
            }
        }




        if (validImgs.length === 0) {
            setErrorMsg("No images intersect with current map bounds");
            map.setOptions({ draggable: true, zoomControl: true });
            return;
        }




        if (validImgs.length > maxFrames) {
            setErrorMsg(`Using first ${maxFrames} of ${validImgs.length} images`);
            validImgs = validImgs.slice(0, maxFrames);
        }




        const gifName = region.toUpperCase() +
            "_S" + moment(dates[0]).format("YYYYMMDD-HHmmss") +
            "_E" + moment(dates[1]).format("YYYYMMDD-HHmmss") +
            "_Step-" + timeStep[0] + "-" + timeStep[1];


            setIsCreatingGif(true);
        // Add a small delay to ensure UI updates before capturing
    await new Promise(resolve => setTimeout(resolve, 100));

        makeGif(validImgs, gifName);
    };




    function polygonToBounds(polygon) {
        let lats = polygon.map(coord => coord[1]);
        let lngs = polygon.map(coord => coord[0]);
        return {
            north: Math.max(...lats),
            south: Math.min(...lats),
            east: Math.max(...lngs),
            west: Math.min(...lngs),
        };
    }




    const makeGif = async (images, gifName) => {
        if (images) {
            var gifImages = []
            for (var i = 0; i < images.length && i < maxFrames; i++) {
                images[i][0] = images[i][0].replace("/home/jundong/www", "");
                const boundsLiteral = polygonToBounds(images[i][2]);
                // console.log((i) + " " + images[i][0]);
                try {
                    await getImage(images[i][0], boundsLiteral, i, gifImages);
                } catch (e) {
                    console.error(`Failed to capture frame ${i}`, e);
                }
            }




            const options = {
                images: gifImages,
                gifWidth: width,
                gifHeight: height,
                numWorkers: 4,
                frameDuration: frameDuration / 100.0,
                sampleInterval: 1,
            };




            createGIF(options, obj => {
                if (!obj.error) {
                    const link = document.createElement('a');
                    link.download = gifName + '.gif';
                    link.href = obj.image;
                    link.click();
                    link.remove();
                } else {
                    setIsCreatingGif(false);
                    setLoading(false);
                }
                setIsCreatingGif(false);
                setIndex(0);
                loadPreviewImages();
            });
            map.setOptions({ draggable: true, zoomControl: true });
        }
    }




    const getImage = (url, bounds, i, gifImages) => {
        return new Promise(function (resolve, reject) {
            var element = document.getElementById('Map')

            if (window.currentOverlay) {
                window.currentOverlay.setMap(null);
            }

            if (timeRoot) {
                timeRoot.render(
                    <div style={{ padding: 5, backgroundColor: "#fff" }}>
                        {imgInfo(url).join(' ')}
                    </div>
                );
            }
            var overlay = new window.google.maps.GroundOverlay(
                url,
                bounds,
                { map: map, opacity: opacity / 100.0 }
            );

            const displayCallback = () => {
                html2canvas(element, {
                    useCORS: true,
                }).then((canvas) => {
                    var link = document.createElement('a');
                    link.download = 'filename.png';
                    link.href = canvas.toDataURL()

                    gifImages[i] = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream")
                    canvas.remove();

                    timeRoot.render(
                        <div >
                        </div>
                    );
                    overlay.setMap(null);
                    resolve(1)
                });
            }

            waitForElementToDisplay('[src*="' + url + '"]', displayCallback, 100, 1000);
        });
    }

    const popover = (
        <Popover id="popover-basic">
          <Popover.Body>
            <h5>Max number of frames: {maxFrames}</h5>
            <ul style={{ paddingLeft: 10}}>
            <li>Select the GIF bounds by panning, zooming, and/or resizing the window, or enter custom latitude/longitude values under "Map Bounds".</li>
              <li>Use the arrows to scroll through the images manually</li>
              <li>Toggle the Loop button preview your GIF before generating it</li>
                <li>
                    <b>Default values are as follows:</b>
                    <ul>
                    <li><b>Start Date:</b> Current UTC Date 00:00 </li>
                    <li><b>End Date:</b> Current UTC Date and Time </li>
                    <li><b>Frame Duration (100-1000ms):</b> 200ms</li>
                    <li><b>Opacity (0-100%):</b> 70%</li>
                    <li><b>Map Bounds:</b> Current view</li>
                    <li><b>Time Step (10min-1day):</b> 10 minutes
                    <ul>
                        <li>Only enabled for mSFR </li>
                    </ul>
                    </li>
                    </ul>
                </li>
            </ul>
            <b style={{color: "red"}}>WARNING</b>: GIF generation may take up to 30 seconds. 
            The GIF will automatically download once ready 
            and can be found in your browser's default download location
          </Popover.Body>
        </Popover>
      );

      const Instructions = () => (
        <OverlayTrigger trigger="click" placement="right" overlay={popover}>
          <Button variant="primary" style={{ fontSize: "20px" }}>Instructions</Button>
        </OverlayTrigger>
      );


    return (
        <div style={{ backgroundColor: 'rgb(218, 227, 243)'}}>
            <Navbar />
            <Container fluid>
                <Row style={{ flexWrap: "nowrap" }}>
                    <Col md="auto" style={{ paddingTop: "10px", width: "390px" }}>
                        <Row xs="auto" className="m-1">
                            {/* <h4>Max number of frames: {maxFrames}</h4> */}
                        </Row>
                        <Row xs="auto" className="m-1">
                            <p><Instructions /></p>
                        </Row>

                        <Form>
                            <Row xs="auto" className="m-2">
                                <Form.Group xs="auto">
                                    <Form.Label htmlFor="region">Region</Form.Label>
                                    <Form.Select
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        onChange={(newRegion) => setRegion(newRegion.target.value)}
                                        id="region"
                                        className="mb-2"
                                        value={region}
                                    >
                                        {Object.entries(regions)
                                            .filter(([key, value]) => value.full_name)
                                            .map(([key, value]) => (
                                                <option key={key} value={key}>
                                                    {value.full_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </Row>


                            <h6 style={{ paddingLeft: "20px", fontWeight: "normal" }}>Start Date and Time (UTC)</h6>
                            <div className="date-picker" style={{ fontSize: "15px" }}>
                                <Row className="align-items-center m-2">
                                    <DatePicker
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                            decreaseYear,
                                            increaseYear,
                                            prevYearButtonDisabled,
                                            nextYearButtonDisabled,
                                        }) => (
                                            <div
                                                style={{
                                                    margin: 10,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <button type="button" onClick={decreaseYear} disabled={prevYearButtonDisabled}>
                                                    {"<<"}
                                                </button>
                                                <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                    {"<"}
                                                </button>
                                                <select
                                                    value={getYear(date)}
                                                    onChange={({ target: { value } }) => changeYear(value)}
                                                >
                                                    {years.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    value={months[getMonth(date)]}
                                                    onChange={({ target: { value } }) =>
                                                        changeMonth(months.indexOf(value))
                                                    }
                                                >
                                                    {months.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                    {">"}
                                                </button>
                                                <button type="button" onClick={increaseYear} disabled={nextYearButtonDisabled}>
                                                    {">>"}
                                                </button>
                                            </div>
                                        )}
                                        selected={dates[0]}
                                        onChange={(date) => handleStartDate(date)}
                                        selectsStart
                                        startDate={dates[0]}
                                        minDate={new Date("2021-10-02")}
                                        maxDate={UTCStartDate}
                                        showYearDropdown
                                        yearDropdownItemNumber={2}
                                        showTimeSelect
                                        timeIntervals={10}
                                        minTime={(new Date()).setHours(0, min = 0)}
                                        maxTime={getStartMaxTime()}
                                        dateFormat="MM/dd/yyyy HH:mm"
                                        timeFormat="HH:mm"
                                    />
                                </Row>
                            </div>





                            <h6 style={{ paddingLeft: "20px", fontWeight: "normal" }}>End Date and Time (UTC)</h6>
                            <div className="date-picker" style={{ fontSize: "15px" }}>
                                <Row className="align-items-center m-2">
                                    <DatePicker
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                            decreaseYear,
                                            increaseYear,
                                            prevYearButtonDisabled,
                                            nextYearButtonDisabled,
                                        }) => (
                                            <div
                                                style={{
                                                    margin: 10,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <button type="button" onClick={decreaseYear} disabled={prevYearButtonDisabled}>
                                                    {"<<"}
                                                </button>
                                                <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                    {"<"}
                                                </button>
                                                <select
                                                    value={getYear(date)}
                                                    onChange={({ target: { value } }) => changeYear(value)}
                                                >
                                                    {years.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    value={months[getMonth(date)]}
                                                    onChange={({ target: { value } }) =>
                                                        changeMonth(months.indexOf(value))
                                                    }
                                                >
                                                    {months.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                    {">"}
                                                </button>
                                                <button type="button" onClick={increaseYear} disabled={nextYearButtonDisabled}>
                                                    {">>"}
                                                </button>
                                            </div>
                                        )}
                                        selected={dates[1]}
                                        onChange={(date) => setDates([dates[0], date])}
                                        selectsEnd
                                        startDate={dates[0]}
                                        endDate={dates[1]}
                                        minDate={dates[0]}
                                        maxDate={getEndMaxDate()}
                                        showYearDropdown
                                        yearDropdownItemNumber={2}
                                        showTimeSelect
                                        timeIntervals={10}
                                        minTime={getEndMinTime()}
                                        maxTime={getEndMaxTime()}
                                        dateFormat="MM/dd/yyyy HH:mm"
                                        timeFormat="HH:mm"
                                    />
                                </Row>
                            </div>


























                            <Row className="align-items-center m-2">
                                <Col xs="6">
                                    <Form.Label htmlFor="frameDuration">
                                        Frame Duration (ms)
                                    </Form.Label>
                                    <Form.Control
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        onChange={(newDuration) => setFrameDuration(newDuration.target.value)}
                                        value={frameDuration}
                                        type='number'
                                        className="mb-2"
                                        id="frameDuration"
                                        placeholder="100-1,000 milliseconds"
                                        min="100"
                                        max="1000"
                                    />
                                </Col>

                                <Col xs="6">
                                    <Form.Label htmlFor="opacity">
                                        Opacity
                                    </Form.Label>
                                    <Form.Control
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        onChange={(newOpacity) => setOpacity(newOpacity.target.value)}
                                        value={opacity}
                                        type='number'
                                        className="mb-2"
                                        id="opacity"
                                        placeholder="0-100%"
                                        min="0"
                                        max="100"
                                    />
                                </Col>

                            </Row>
                            <Row className="align-items-center m-2">
                                <Col xs="12">
                                    <Form.Label><strong>Map Bounds</strong></Form.Label>
                                    <div className="mb-2">
                                    <Button 
                                    
                                    className="reset-button"
                                    style={{ fontSize: "14px" }}
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={resetMapBounds}
                                >
                                    Reset to Region
                                </Button>


                                    </div>
                                </Col>
                            </Row>
                            <Row className="align-items-center m-2">
                                <Col xs="6">
                                    <Form.Label>North</Form.Label>
                                    <Form.Control
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        type='number'
                                        step="any"
                                        className="mb-2"
                                        placeholder="Max Latitude"
                                        onChange={(e) => setCustomBounds(prev => ({ ...prev, north: parseFloat(e.target.value) }))}
                                    />
                                </Col>
                                <Col xs="6">
                                    <Form.Label>South</Form.Label>
                                    <Form.Control
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        type='number'
                                        step="any"
                                        className="mb-2"
                                        placeholder="Min Latitude"
                                        onChange={(e) => setCustomBounds(prev => ({ ...prev, south: parseFloat(e.target.value) }))}
                                    />
                                </Col>
                            </Row>
                            <Row className="align-items-center m-2">
                                <Col xs="6">
                                    <Form.Label>East</Form.Label>
                                    <Form.Control
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        type='number'
                                        step="any"
                                        className="mb-2"
                                        placeholder="Max Longitude"
                                        onChange={(e) => setCustomBounds(prev => ({ ...prev, east: parseFloat(e.target.value) }))}
                                    />
                                </Col>
                                <Col xs="6">
                                    <Form.Label>West</Form.Label>
                                    <Form.Control
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        type='number'
                                        step="any"
                                        className="mb-2"
                                        placeholder="Min Longitude"
                                        onChange={(e) => setCustomBounds(prev => ({ ...prev, west: parseFloat(e.target.value) }))}
                                    />
                                </Col>
                            </Row>

                            <Row xs="auto" className="m-2">
                                <Form.Group xs="auto">
                                    <Form.Label htmlFor="timeStep">Time Step</Form.Label>
                                    <Form.Select
                                    style={{
                                        border: "1px solid #ccc",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        backgroundColor: "white"
                                      }}
                                        onChange={(newTimeStep) => setTimeStep(newTimeStep.target.value.split(","))}
                                        id="timeStep"
                                        className="mb-2"
                                        value={region === "msfr" ? timeStep.join(",") : ""}
                                        disabled={region !== "msfr"}
                                    >
                                        {region !== "msfr" && <option value="">--</option>}
                                        <option value={"10,minutes"}>10 minutes</option>
                                        <option value={"30,minutes"}>30 minutes</option>
                                        <option value={"1,hours"}>1 Hour</option>
                                        <option value={"2,hours"}>2 Hours</option>
                                        <option value={"4,hours"}>4 Hours</option>
                                        <option value={"12,hours"}>12 Hours</option>
                                        <option value={"1,days"}>1 Day</option>
                                    </Form.Select>
                                </Form.Group>


                                <Button
                                onClick={handleClick}
                                className="m-4"
                                disabled={!images || images.length === 0 || loading || isCreatingGif}
                                >
                                {isCreatingGif 
                                    ? "Creating GIF..." 
                                    : (loading ? "Loading..." : "Generate GIF")}
                                </Button>
                            </Row>




                            <Row className="align-items-center m-2">
                                <p style={{ color: "red" }}>
                                    {errorMsg}
                                </p>
                            </Row>
                        </Form>
                    </Col>
                    <Col md="auto">
                        <div id='GoogleMap'>
                            <LoadScript
                                googleMapsApiKey={process.env.REACT_APP_API_KEY}
                            >
                                <GoogleMap
                                    id='Map'
                                    mapContainerStyle={{
                                        width: `${width}px`,
                                        height: `${height}px`
                                    }}




                                    center={regions[region]["center"]}
                                    zoom={regions[region]["zoom"]}
                                    options={{
                                        isFractionalZoomEnabled: true,
                                        streetViewControl: false,
                                        mapTypeControl: false,
                                        fullscreenControl: false,
                                        cameraControl: false,
                                        zoomControl: zoomControl,
                                    }}
                                    onLoad={map => handleOnLoad(map)}
                                >
                                    {!isCreatingGif && images && images[index] && images[index][0] && images[index][1] ?
                                        <GroundOverlay
                                            key={images[index][0]}
                                            url={images[index][0]}
                                            bounds={polygonToBounds(images[index][2])}
                                            opacity={opacity / 100.0}
                                        /> : null
                                    }
                                </GoogleMap>
                            </LoadScript>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}




export default GenerateGif;




/* Takes a starting date and stopping date and returns all the dates between them as an array inclusive */
function getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDateMoment = moment(stopDate);
    while (currentDate <= stopDateMoment) {
        var formatDate = moment(currentDate).format('YYYYMMDD');
        dateArray.push([formatDate.substring(0, 4), formatDate.substring(4, 6), formatDate.substring(6, 8)]);
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}




const imgInfo = img => {
    const imgRegex = /[0-9]{8}_[0-9]{6}/;
    var vals = img.match(imgRegex)[0].split('_');
    vals[0] = vals[0].substring(4, 6) + '/' + vals[0].substring(6, 8) + '/' + vals[0].substring(0, 4);
    vals[1] = vals[1].substring(0, 2) + ':' + vals[1].substring(2, 4) + ':' + vals[1].substring(4, 6) + ' UTC';
    
    const satellites = config["satellites"] || {};

        for (var key in satellites) {
            if (img.includes(key)) {
                vals.unshift(satellites[key].description_name);
                break;
            }
        }
    return vals;
};




function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        }
        else {
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}